import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Place.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import PlaceImageBlock from './PlaceImageBlock'
import PlaceInfo from './PlaceInfo'
import PlaceCommentsContainer from '../PlaceCommentsContainer'
import PlacePostsContainer from '../PlacePostsContainer'
import PlaceRecommendsContainer from '../PlaceRecommendsContainer'
import { getContext } from '@hocs'
import { PlaceType } from '@app-core/place/reducer'

class Place extends Component {
  shouldComponentUpdate(nextProps) {
    //props
    if (this.props.placeId !== nextProps.placeId) {
      return true
    }
    // default:false
    return false
  }

  render() {
    const {
      placeId,
      placeType,
      placeData,
      openOpenHoursPop,
      editCurrentUserComment,
      onClickedMore,
      giftData,
    } = this.props
    return (
      <div className="place">
        <style jsx>{styles}</style>
        <PlaceImageBlock placeData={placeData.toJS()} onClickedMore={onClickedMore} />
        <PlaceInfo
          placeData={placeData}
          giftData={giftData}
          openCommentPop={editCurrentUserComment}
          openOpenHoursPop={openOpenHoursPop}
        />
        {placeType === PlaceType.choice && <PlaceCommentsContainer placeId={placeId} />}
        <PlaceRecommendsContainer placeId={placeId} />
        <PlacePostsContainer placeId={placeId} />
      </div>
    )
  }
}

export default getContext({
  placeType: PropTypes.string.isRequired,
})(Place)
